export const environment = {
  production: false,
  apiUrl: 'https://devapi.prismcalifornia.org/',
  url: 'https://dev.prismcalifornia.org/',
  authToken: 'prism-token',
  storageName: "prismdevstorage",
  storageUrl: 'storageUrl',
  encryptionKey: "4a25f88fcac1b07e93a6dba85e3018e7",
  recaptcha: {
    siteKey: '6LeJa28pAAAAABobnV8yAVYQ81TvqIPBWW21mQOy',
  },
  gaTrackingId: 'G-PB07FV08HC',
  uploadFileUrl: `https://prismdevstorage.blob.core.windows.net`,
  uploadFileLink: `https://prismdevstorage.blob.core.windows.net/resources/user/Prism-BulkUserUploadTemplate.xlsx`,
  heroVideo: 'assets/videos/prism-hero-vid.mp4',
  appinsights: `InstrumentationKey=a3a4eb0d-9353-410b-bf04-7ecdcef72f07;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=88868910-af53-45b4-a39c-e1ae3b1a6ec2`,
  refreshThresholdMinutes: 10, // Adjusted for session monitoring
  courseTimeoutMinutes: 20, // Adjusted for course timeout
  isSiteOffline: false
};
